import { has, set, get, map, unset } from 'lodash'
import { AxiosResponse } from 'axios'

export const errorMixin = {
  data () {
    return {
      errorHandlerMixin_violations: {}
    }
  },
  methods: {
    clearViolations () {
      /**
       * @ts-expect-error
       */
      this.errorHandlerMixin_violations = []
    },
    clearViolation (propertyPath: string) {
      /**
       * @ts-expect-error
       */
      unset(this.errorHandlerMixin_violations, propertyPath)
    },
    hasViolation (propertyPath: string): boolean {
      if (propertyPath === '') {
        return false
      }

      /**
       * @ts-expect-error
       */
      return has(this.errorHandlerMixin_violations, propertyPath)
    },
    getViolation (propertyPath: string | []): string | null {
      if (propertyPath === '') {
        return null
      }

      if (Array.isArray(propertyPath)) {
        let violation = null

        propertyPath.forEach((path) => {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          if (this.hasViolation(path)) {
            /**
             * @ts-expect-error
             */
            violation = get(this.errorHandlerMixin_violations, path)
          }
        })

        return violation
      } else {
        /**
         * @ts-expect-error
         */
        return get(this.errorHandlerMixin_violations, propertyPath)
      }
    },
    setViolation (message: string, propertyPath: string): void {
      /**
       * @ts-expect-error
       */
      if (typeof this.errorHandlerMixin_violations === 'undefined') {
        /**
         * @ts-expect-error
         */
        this.$set(this, 'errorHandlerMixin_violations', {})
      }

      /**
       * @ts-expect-error
       */
      if (!has(this.errorHandlerMixin_violations, propertyPath)) {
        /**
         * @ts-expect-error
         */
        set(this.errorHandlerMixin_violations, propertyPath, [])
      }

      /**
       * @ts-expect-error
       */
      this.errorHandlerMixin_violations[propertyPath].push(message)
    },
    buildViolations (err: AxiosResponse): void {
      if (!has(err, 'data.violations')) {
        return
      }

      const violations = {}

      /**
       * @ts-ignore
       * @ts-expect-error
       */
      map(err.data.violations, (value) => {
        if (has(value, 'title')) {
          set(violations, value.propertyPath, value.title)
        }

        if (has(value, 'message')) {
          set(violations, value.propertyPath, value.message)
        }
      })

      /**
       * @ts-expect-error
       */
      this.errorHandlerMixin_violations = violations
    }
  }
}
